import React from 'react';
import { Form } from '@themesberg/react-bootstrap';

const VendorPermissionFields = ({ formik }) => (
  <fieldset className="border rounded p-3 mb-3" disabled={formik.isSubmitting}>
    <legend className="h6 mb-3">Vendor Permissions</legend>
    <Form.Check
      type="switch"
      id="allow-multiple-companies"
      name="allow_multiple_companies"
      label="Allow multiple companies"
      checked={Boolean(formik.values.allow_multiple_companies)}
      onChange={event => formik.setFieldValue('allow_multiple_companies', event.target.checked)}
      onBlur={formik.handleBlur}
      isInvalid={Boolean(formik.errors.allow_multiple_companies)}
    />
    <Form.Text className="text-muted">
      Vendors can create one company by default. Enable this to allow additional companies.
    </Form.Text>
    {formik.errors.allow_multiple_companies && (
      <div className="invalid-feedback d-block">{formik.errors.allow_multiple_companies}</div>
    )}
  </fieldset>
);

export default VendorPermissionFields;
